import { render } from "./update-company.vue?vue&type=template&id=537dd663&scoped=true"
import script from "./update-company.vue?vue&type=script&lang=js"
export * from "./update-company.vue?vue&type=script&lang=js"

import "./update-company.vue?vue&type=style&index=0&id=537dd663&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537dd663"],['__file',"src/components/applications/admin/update/update-company.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "537dd663"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('537dd663', __exports__)) {
    api.reload('537dd663', __exports__)
  }
  
  module.hot.accept("./update-company.vue?vue&type=template&id=537dd663&scoped=true", () => {
    api.rerender('537dd663', render)
  })

}


export default __exports__